import Vue from 'vue'
import Router from 'vue-router'
import Login from '@/views/Login.vue'
import UserRoute from '@/views/User/router'
import AgentRoute from '@/views/Agent/router'
import ContractRoute from '@/views/Contract/router'
import SpecialOfferRoute from '@/views/SpecialOffer/router'
import HotelRoute from '@/views/Hotel/router'
import EmailRoute from '@/views/Email/router'
import SettingRoute from '@/views/Setting/router'
import localStorageFactory from '@/factories/local-storage-factory'
import store from '@/store'
import { VUEX_EVENT } from '@/configs/constant'

Vue.use(Router)

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      redirect: '/hotel'
    },
    {
      path: '/user',
      component: () => import(/* webpackChunkName: "user" */ '@/views/User/Index.vue'),
      children: UserRoute
    },
    {
      path: '/agent',
      component: () => import(/* webpackChunkName: "agent" */ '@/views/Agent/Index.vue'),
      children: AgentRoute
    },
    {
      path: '/contract',
      component: () => import(/* webpackChunkName: "contract" */ '@/views/Contract/Index.vue'),
      children: ContractRoute
    },
    {
      path: '/special-offer',
      component: () => import(/* webpackChunkName: "special-offer" */ '@/views/SpecialOffer/Index.vue'),
      children: SpecialOfferRoute
    },
    {
      path: '/login',
      name: 'Login',
      component: Login
    },
    {
      path: '/hotel',
      component: () => import(/* webpackChunkName: "hotel" */ '@/views/Hotel/Index.vue'),
      children: HotelRoute
    },
    {
      path: '/email',
      component: () => import(/* webpackChunkName: "email" */ '@/views/Email/Index.vue'),
      children: EmailRoute
    },
    {
      path: '/setting',
      component: () => import(/* webpackChunkName: "setting" */ '@/views/Setting/Index.vue'),
      children: SettingRoute
    }
  ]
})

router.beforeEach(async (to, from, next) => {
  const activeHotelId = store.getters['general/getActiveHotelId']

  if (activeHotelId === '') {
    const hotelDetail = await localStorageFactory.getHotelDetail()
    if (hotelDetail) {
      await store.dispatch(VUEX_EVENT.GENERAL.RESTORE_STATE, hotelDetail)
    }
  }

  next()
})

export default router
